import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "third-login"
};
const _hoisted_2 = {
  key: 0,
  class: "item"
};
const _hoisted_3 = ["href"];
const _hoisted_4 = {
  key: 0,
  class: "text ok"
};
const _hoisted_5 = {
  key: 1,
  class: "text"
};
import { computed, ref, watch } from "vue";
import { httpGet } from "@/utils/http";
import { checkSession } from "@/store/cache";
import { showMessageError } from "@/utils/dialog";
export default {
  __name: 'ThirdLogin',
  props: {
    show: Boolean
  },
  emits: ['hide'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const showDialog = computed(() => {
      return props.show;
    });
    const title = ref('绑定第三方登录');
    const openid = ref('');
    const wechatBindURL = ref('');
    const loading = ref(true);
    watch(showDialog, val => {
      if (val) {
        checkSession().then(user => {
          openid.value = user.openid;
        });
        const returnURL = `${location.protocol}//${location.host}/login/callback?action=bind`;
        httpGet("/user/clogin?return_url=" + returnURL).then(res => {
          wechatBindURL.value = res.data.url;
          loading.value = false;
        }).catch(e => {
          showMessageError(e.message);
        });
      }
    });
    const close = function () {
      emits('hide');
    };
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showDialog.value = $event),
        "close-on-click-modal": true,
        style: {
          "max-width": "400px"
        },
        onClose: close,
        title: title.value
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [wechatBindURL.value !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("a", {
          class: "link",
          href: wechatBindURL.value
        }, _cache[1] || (_cache[1] = [_createElementVNode("i", {
          class: "iconfont icon-wechat"
        }, null, -1)]), 8, _hoisted_3), openid.value !== '' ? (_openBlock(), _createElementBlock("span", _hoisted_4, "已绑定")) : (_openBlock(), _createElementBlock("span", _hoisted_5, "未绑定"))])) : _createCommentVNode("", true)])), [[_directive_loading, loading.value]])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};